import useFilter from '@components/Items/utils/hooks/useFilter'
import Pill from '@components/Items/Filters/Active/Pill'
import { QUERY_KEYS } from '@components/Items/utils/functions'
import _isEmpty from 'lodash/isEmpty'

const Categories = () => {
  const { categoryJsonQuery, updateQuery } = useFilter()

  if (!categoryJsonQuery) return <></>

  const category1List = Object.entries(categoryJsonQuery)

  return (
    <>
      {category1List.map(([category1, category2List]) =>
        category2List.map((category2) => (
          <Pill
            key={`pill-categories-${category1}-${category2}`}
            label={category2}
            onClick={() => {
              const index = categoryJsonQuery[category1].indexOf(category2)
              categoryJsonQuery[category1].splice(index, 1)

              if (categoryJsonQuery[category1].length === 0) {
                delete categoryJsonQuery[category1]
              }

              updateQuery(
                QUERY_KEYS.CATEGORIES,
                encodeURIComponent(
                  !_isEmpty(categoryJsonQuery)
                    ? JSON.stringify(categoryJsonQuery)
                    : ''
                )
              )
            }}
          />
        ))
      )}
    </>
  )
}

export default Categories
